import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import IconButton from '@mui/material/IconButton';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ImagePreview from '../ImagePreview';
import { useState } from 'react';
import AWS from 'aws-sdk';
import { useEffect } from 'react';

const ImageUploadContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  maxWidth: '380px',
  maxHeight: '688px',
  gap: '24px',
  [theme.breakpoints.down('md')]: {
    width: '366px',
    marginBottom: '25px',
  },
}));

const ImageUploadForm = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '380px',
  height: '550px',
  backgroundColor: '#E0E0E0',
  borderRadius: '2px',
  boxShadow: '0 2px 2px rgba(0, 0, 0, 0.3)',
  [theme.breakpoints.down('md')]: {
    width: '366px',
    height: '346px',
  },
}));

const DragAndClickLabel = styled('label')(({ theme }) => ({
  display: 'flex',
  width: '352px',
  height: '530px',
  margin: 'auto',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px dashed #999999',
  [theme.breakpoints.down('md')]: {
    width: '338px',
    height: '316px',
  },
}));

const DragAndClickBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

const TextTypography = styled(Typography)(() => ({
  fontFamily: 'Raleway',
  fontWeight: '400',
  fontSize: '20px',
  lineHeight: '23px',
  display: 'flex',
  alignItems: 'center',
  color: '#717171',
}));

const albumBucketName = 'coffeetopia';
const albumName = 'note-create-pics';
const REGION = 'ap-southeast-2';
const identityPoolId = 'ap-southeast-2:31a8b407-3dd5-453a-8bee-3182d5d658e4';

AWS.config.update({
  region: REGION,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: identityPoolId,
  }),
});

export default function ImageUpload({ formik }) {
  const MAX_LENGTH = 8;
  const [selectedImages, setSelectedImages] = useState([]);

  useEffect(() => {
    formik.setFieldValue('attachmentData', selectedImages.length > 0 ? selectedImages : []);
  }, [selectedImages]);

  const addPhoto = async (file, albumName) => {
    if (file === undefined) {
      return;
    }
    const albumPicturesKey = encodeURIComponent(albumName) + '/';
    let photoKey = albumPicturesKey + file.name;

    let upload = new AWS.S3.ManagedUpload({
      params: {
        Bucket: albumBucketName,
        Key: photoKey,
        Body: file,
      },
    });
    let promise = upload.promise();

    promise.then(
      function (data) {
        const imageInfo = { url: data.Location, name: data.key };

        setSelectedImages((prev) => {
          if (prev.concat(imageInfo).length > MAX_LENGTH) {
            alert(`Cannot upload files more than ${MAX_LENGTH}`);
            return prev;
          }
          return prev.concat(imageInfo);
        });
      },
      function (err) {
        return alert('There was an error uploading your photo: ', err.message);
      }
    );
  };

  const OnSelectFile = (e) => {
    e.preventDefault();
    const selectedPictures = e.target.files;
    const file = selectedPictures[0];
    addPhoto(file, albumName);
    e.target.value = null;
  };

  const dragOver = (e) => e.preventDefault();
  const dragEnter = (e) => e.preventDefault();
  const dragLeave = (e) => e.preventDefault();
  const fileDrop = (e) => {
    e.preventDefault();
    const selectedPictures = e.dataTransfer.files;
    const file = selectedPictures[0];
    addPhoto(file, albumName);
  };

  const selectDeleted = (index) => {
    const newSelectedImages = selectedImages.filter((image, i) => i !== index);
    setSelectedImages(newSelectedImages);
  };

  return (
    <ImageUploadContainer>
      <ImageUploadForm
        onDragOver={dragOver}
        onDragEnter={dragEnter}
        onDragLeave={dragLeave}
        onDrop={fileDrop}
      >
        <input hidden type="file" id="input-file-upload" multiple={true} onChange={OnSelectFile} />
        <DragAndClickLabel id="label-file-upload" htmlFor="input-file-upload">
          <DragAndClickBox>
            <IconButton aria-label="upload picture" component="label">
              <input hidden accept="image/*" type="file" multiple={true} onChange={OnSelectFile} />
              <AddPhotoAlternateIcon sx={{ fontSize: 34 }} />
            </IconButton>
            <TextTypography>Drag and drop or click to upload</TextTypography>
          </DragAndClickBox>
        </DragAndClickLabel>
      </ImageUploadForm>
      <ImagePreview images={selectedImages} deleteHandler={selectDeleted} />
    </ImageUploadContainer>
  );
}
